// Declare both the type and value of each constant to be the same string literal so that flow doesn't infer the type of
// each constant to be 'string' which is too general. We want it to be limited to a more specific type that can contain
// only one specific string.
export const NOT_REGISTERING = 'NOT_REGISTERING';
export const STARTING_REGISTRATION = 'STARTING_REGISTRATION';
export const REGISTERING = 'REGISTERING';
export const SAVING_REGISTRATION = 'SAVING_REGISTRATION';
export const CHECKING_OUT = 'CHECKING_OUT';
export const CHECKED_OUT = 'CHECKED_OUT';
export const CHECKED_OUT_PARTIALLY = 'CHECKED_OUT_PARTIALLY';
export const CANCELLING = 'CANCELLING';
export const FINALIZED_CANCEL_REGISTRATION = 'FINALIZED_CANCEL_REGISTRATION';
export const DECLINED_REGISTRATION = 'DECLINED_REGISTRATION';

export const RegistrationIntent =
  typeof NOT_REGISTERING | typeof STARTING_REGISTRATION | typeof REGISTERING | typeof SAVING_REGISTRATION |
    typeof CHECKING_OUT | typeof CHECKED_OUT | typeof CHECKED_OUT_PARTIALLY |
    typeof CANCELLING | typeof FINALIZED_CANCEL_REGISTRATION | typeof DECLINED_REGISTRATION;
